import { resolveAssetUrl } from "../../resolveAssetUrl";
import { TextNodeType } from "../../CommonLandingMweb.types";
import {
  BulletIcon,
  Card,
  CardInner,
  Container,
  CTA,
  CtaLabel,
  DefaultBullet,
  FeatureRow,
  Features,
  Header,
  HeroImage,
  Row,
  Title,
} from "./Styles";
import FormattedText from "../../../FormattedText/FormattedText";
import { navigationActions } from "@tm/insurance/navigation";

interface CarouselListItem {
  icon?: string | Record<string, unknown>;
  stats?: TextNodeType;
}

interface TripProtectionCard {
  id?: string | number;
  header?: TextNodeType;
  img?: string | Record<string, unknown>;
  list?: CarouselListItem[];
  cta?: { title?: TextNodeType; deeplink?: string; type?: string; config?: any };
}

interface TripProtectionCarouselProps {
  title?: TextNodeType;
  cards?: TripProtectionCard[];
}

export const TripProtectionCarousel = ({
  title,
  cards = [],
}: TripProtectionCarouselProps) => {
  if (!cards.length) return null;

  const onCardPress = (card: TripProtectionCard) => {
    if (card.cta?.deeplink) {
      let route = card.cta?.deeplink;
      if (
        route?.startsWith("/insurance") &&
        !window.location.pathname.includes("/travel-insurance")
      ) {
        route = route.replace("/insurance", "");
      }
      navigationActions.navigateToPageByRouteName(route);
    }
  };

  return (
    <Container>
      <Title>
        <FormattedText value={title || "Explore Trip Protection Plans"} />
      </Title>
      <Row>
        {cards.map((card, idx) => {
          const heroUrl = resolveAssetUrl(card.img);
          const isFirstCard = idx === 0;
          return (
          <Card
            key={`${card.id ?? idx}`}
            role="button"
            tabIndex={0}
            onClick={() => onCardPress?.(card)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onCardPress(card);
              }
            }}
          >
            <CardInner>
              {card.header ? (
                <Header>
                  <FormattedText value={card.header} />
                </Header>
              ) : null}
              {heroUrl ? (
                <HeroImage
                  src={heroUrl}
                  alt=""
                  loading={isFirstCard ? "eager" : "lazy"}
                  fetchPriority={isFirstCard ? "high" : undefined}
                  decoding={isFirstCard ? "async" : "auto"}
                />
              ) : null}
              {card.list && card.list.length > 0 ? (
                <Features>
                  {card.list.map((item, itemIdx) => {
                    const bulletUrl = resolveAssetUrl(item.icon);
                    return (
                    <FeatureRow key={`${idx}-li-${itemIdx}`}>
                      {bulletUrl ? (
                        <BulletIcon src={bulletUrl} alt="" />
                      ) : (
                        <DefaultBullet aria-hidden />
                      )}
                      <div>
                        <FormattedText value={item.stats} />
                      </div>
                    </FeatureRow>
                    );
                  })}
                </Features>
              ) : null}
              {card.cta?.title ? (
                <CTA>
                  <CtaLabel>
                    <FormattedText value={card.cta.title} />
                  </CtaLabel>
                </CTA>
              ) : null}
            </CardInner>
          </Card>
          );
        })}
      </Row>
    </Container>
  );
};
